angular.module('eStories.headers.tribook', [])
    .component('tribookHeader', {
        transclude: true,
        bindings: {
            audiobookList: '<',
            title: '@'
        },
        controller: 'TribookHeaderCtrl',
        controllerAs: 'tribookHeaderCtrl',
        templateUrl: '/components/headers/tribook/tribook-header.tmpl.html'
    }).controller('TribookHeaderCtrl',
    ['$scope', 'CatalogModel', 'PagingModel', function ($scope, CatalogModel, PagingModel) {
        this.populateDisplayBooks = async (audiobookList) => {
            this.displayBooks = [];
            if (!audiobookList || audiobookList.length < 3) {
                // Fill books from most popular this month
                const pagination = PagingModel.preparePagination(1, 40, true, false, 'MOST_POPULAR_THIS_MONTH');
                const response = await CatalogModel.getAllAudiobooks({}, pagination, null);
                audiobookList = response.audiobookList;
            }
            this.displayBooks = shuffleArray(audiobookList).slice(0, 3);
            safeApply($scope);
        };

        if (this.audiobookList && this.audiobookList.length >= 3) {
            this.populateDisplayBooks(this.audiobookList).then();
        }
        // noinspection JSUnusedGlobalSymbols
        this.$onChanges = async (changes) => {
            if (changes.audiobookList) {
                await this.populateDisplayBooks(changes.audiobookList.currentValue);
            }
        };
    }]
);
